export enum MaskModeTypes {
    NONE = 'NONE',
    ALPHA = 'ALPHA',
    ALPHA_INVERTED = 'ALPHA_INVERTED',
}
